import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../styles/diario.scss';

const Diaria = (props) => {


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchDiarias()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Header><h5>Índice {props.diaria.indice} para o cargo {props.diaria.cargo}</h5></Card.Header>
                    <Card.Body>
                        <p>Distância: {props.diaria.distancia}</p>
                        <p>Valor: {props.diaria.valor}</p>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.diaria._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.diaria._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Diaria;